import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Unpin from './unpin.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Unpin {...validProps} />;
}
SvgComponent.iconName = 'unpin';

/**
 * @deprecated This is a legacy icon
 */
export const UnpinIcon = svgIconWrapper(SvgComponent);
